import { EditorSession } from '../../canvas/EditorSession';
import { Selection, SelectionSet } from '../../canvas/Selection';
import { ActiveObject, resolve } from '../../Container';
import { Shape } from './Shape';

/**
 * An active object that tracks the selection looking for Shape components.  The most recent Shape selected will be tracked and used, when
 * required, by the shapeTool to auto configure the next Shape's settings.  We don't want to take a shapeshot of the state until we really
 * need it, which is why we just track it and don't so we just need to make sure its still alive when we do come to make the snapshot.
 */
export class ShapeAutoConfigure extends ActiveObject {

    @resolve(EditorSession) private session!: EditorSession;

    private currentTarget = null as Shape | null;

    public start = () => this.burden(
        this.session.observe(Selection, this.selectNextCopyTarget)
    );

    public getAutoState(): any {
        const ct = this.currentTarget;
        if (!ct || !ct.alive) return false;
        const props = ['background', 'cornerRadius', 'kind', 'sides', 'stroke', 'style',];
        const values = {} as any;
        for (const p of props) {
            values[p] = ct.get(p);
        }
        return values;
    }

    private selectNextCopyTarget = (selection: SelectionSet) => {
        for (const c of selection) {
            const s = c.as(Shape);
            if (s) this.currentTarget = s;
        }
    };
}
